<template>
  <v-list-group
    v-if="display"
    :value="value"
    :prepend-icon="icons.cashier"
    no-action
    color="white"
    active-class="primary"
    @input="$emit('input', $event)"
  >
    <template #activator>
      <v-list-item-content>
        <v-list-item-title>{{ __('cashControl') }}</v-list-item-title>
      </v-list-item-content>
    </template>

    <v-list-item v-if="isManual" @click="drawerTurn()">
      <v-list-item-title>{{ __(openingTurn ? 'openTurn' : 'closeTurn') }}</v-list-item-title>
    </v-list-item>

    <v-list-item v-if="can('inout')" @click="inOut()">
      <v-list-item-title>{{ __('inOut') }}</v-list-item-title>
    </v-list-item>

    <v-list-item v-if="viewReportX" @click="report('X')">
      <v-list-item-title>{{ __('reportX') }}</v-list-item-title>
    </v-list-item>

    <v-list-item v-if="viewReportZ" @click="report('Z')">
      <v-list-item-title>{{ __('reportZ') }}</v-list-item-title>
    </v-list-item>

  </v-list-group>
</template>

<script>
  import { mapGetters } from 'vuex'
  import I18n from '@/Mixins/I18n'
  import InteractsWithLoading from '@/Mixins/InteractsWithLoading'
  import ManagesTurns from '@/Mixins/ManagesTurns'
  import NeedsPermission from '@/Mixins/NeedsPermission'
  import UsesIcons from '@/Mixins/UsesIcons'
  import CashControl from '@/Models/Static/Business/CashControlType'

  export default {
    mixins: [
      I18n,
      InteractsWithLoading,
      ManagesTurns,
      NeedsPermission,
      UsesIcons,
    ],

    props: {
      value: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      CashControl,
    }),

    computed: {
      ...mapGetters('rummage', [
        'business',
      ]),
      cashControlType () {
        return this.business('cashControlType')
      },
      blindCashier () {
        return !! this.business('blindCashier')
      },
      isManual () {
        return this.CashControl.isManual(this.cashControlType)
      },
      display () {
        // from XEF's Controllers/Options/Options/OptionCashControl.swift
        return this.can('turns') && this.cashControlType != this.CashControl.NONE
      },
      viewReportX () {
        // from XEF's Controllers/Options/Turns/OptionReportX.swift
        return !! this.turn && ! this.blindCashier
      },
      viewReportZ () {
        // from XEF's Controllers/Options/Turns/OptionReportZ.swift
        return ! this.turn || ! this.blindCashier
      },
    },

    methods: {
      drawerTurn () {
        this.startLoading()
        this.setTurn().finally(() => {
          this.stopLoading()
          this.$emit('close')
        })
      },
      inOut () {
        this.$store.dispatch('cashControl/getTurn')
          .then(() => this.$emit('open', 'inOut'))
          .catch(e => this.manageTurn(e))
      },
      report (v) {
        this.$store.dispatch('cashControl/report/open', v)
        this.$emit('close')
      },
    },
  }
</script>
